import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React, { useRef } from 'react'
import styled from 'styled-components'

import theme from '../components/atoms/theme'

const { breakpoints } = theme

type ParallaxPropTypes = {
  children?: React.JSX.Element
  image?: IGatsbyImageData | null
  visibleOverflow?: boolean
  focalRatio?: {
    x: number
    y: number
  } | null
}

const ParallaxContainer = styled.div`
  position: relative;
  height: 100%;
`

type StyledParallaxProps = {
  visibleOverflow?: boolean
}

const ParallaxWrapper = styled.div<StyledParallaxProps>`
  height: 100%;
  overflow: ${(props) => (props.visibleOverflow ? 'visible' : 'hidden')};

  @media only screen and ${breakpoints.fromNormalScreen} {
    overflow: hidden;
  }
`

const Parallax = (props: ParallaxPropTypes): React.JSX.Element => {
  const parallaxWrapper = useRef<HTMLDivElement | null>(null)
  const computedObjectPosition = props.focalRatio
    ? `${props.focalRatio.x}% ${props.focalRatio.y}%`
    : 'center center'

  return (
    <ParallaxWrapper
      ref={parallaxWrapper}
      visibleOverflow={props.visibleOverflow}
    >
      <ParallaxContainer>
        {props.image && (
          <GatsbyImage
            image={props.image}
            alt='Background image'
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
            imgStyle={{
              objectFit: 'cover',
              objectPosition: computedObjectPosition,
            }}
          />
        )}
      </ParallaxContainer>
      {props.children}
    </ParallaxWrapper>
  )
}

export default Parallax
